import { VestingNotImportedData } from 'Modules'
import { parseEther } from 'viem'

export interface FlattenedEntry {
  user: `0x${string}`
  signDateSec: number
  amount: number
  amountWei: bigint
}

export const mapNotImportedToEntries = (results: VestingNotImportedData[]): FlattenedEntry[] => {
  return results
    .filter(
      (item) => Number.isFinite(Number(item.signDate)) && Number.isFinite(Number(item.amount))
    )
    .map((item) => ({
      user: item.ownerAddress as `0x${string}`,
      signDateSec: Number(item.signDate),
      amount: Number(item.amount ?? 0),
      amountWei: parseEther(String(item.amount ?? 0)),
    }))
}
